import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { Theme, PaletteColor } from "@mui/material/styles";

// Utility to resolve a fill token (e.g. "red.200") to a real color from the theme
function resolveTokenFill(theme: Theme, fill: string): string {
    const [key, shade] = fill.split(".") as [keyof Theme["palette"], keyof PaletteColor];
    const colorGroup = theme.palette[key] as PaletteColor | undefined;
    return colorGroup?.[shade] || fill;
}

/**
 * SvgIcon that supports theme palette color tokens for the fill property.
 * Usage: <ThemedFillSvgIcon sx={{ fill: "red.200" }} ... />
 */
export const ThemedFillSvgIcon = (props: SvgIconProps) => {
    const { sx, ...rest } = props;
    return (
        <SvgIcon
            {...rest}
            sx={{
                ...sx,
                fill: theme => {
                    let fillValue: string | undefined;
                    if (sx && typeof sx === "object" && !Array.isArray(sx) && "fill" in sx) {
                        fillValue = (sx as Record<string, unknown>).fill as string;
                    }
                    return fillValue ? resolveTokenFill(theme, fillValue) : undefined;
                },
            }}
        >
            {props.children}
        </SvgIcon>
    );
};
